module.exports = __webpack_public_path__ + "static/media/RockEmoji.b6982b55.png";